var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"id":"fieldset-1","description":"例:[id,name], [*.*]でリレーションを取得","label":"フィールド","label-for":"input-1"}},[_c('b-form-input',{model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }